import { render, staticRenderFns } from "./index.vue?vue&type=template&id=c0cfd878&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=c0cfd878&lang=scss&scoped=true&"
import style1 from "./index.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0cfd878",
  null
  
)

export default component.exports